import React from "react";
import { C, YEARS, fmt, fyl } from "./shared";

const STATUS = {
  healthy: { label: "HEALTHY", bg: "rgba(44,197,168,0.15)", color: C.green },
  tight: { label: "TIGHT", bg: "rgba(245,158,11,0.15)", color: C.orange },
  breach: { label: "BELOW 1.0×", bg: "rgba(248,113,113,0.15)", color: C.red },
};

export default function Dscr({ out }) {
  const d = out.dscr;
  const yl = fyl(out);
  const cap = d.capacity;
  const rows = [
    ["ebitda", "EBITDA"], ["tax", "Less: tax"], ["cfads", "CFADS — cash available for debt service"],
    ["interest", "Interest"], ["principal", "Principal repaid"], ["debt_service", "Total debt service"],
  ];
  return (
    <div data-testid="fm-dscr" className="max-w-4xl space-y-5">
      <div className="text-xs text-white/45">
        Section J · DSCR & Debt Capacity — lenders divide the cash your plan generates by what the debt costs each year. They want at least {d.target_dscr}× cover.
      </div>
      <div className="rounded-xl p-5" data-testid="fm-dscr-advice"
        style={{ backgroundColor: C.panel, border: "1px solid rgba(123,211,206,0.2)" }}>
        <div className="text-sm font-extrabold mb-1" style={{ color: C.tealSoft }}>Debt Capacity Advisor</div>
        <p className="text-sm text-white/75">{d.advice}</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4">
          {[["Max sustainable debt", fmt(cap.max_debt), "fm-dscr-maxdebt"],
            ["Debt already in plan", fmt(cap.existing_principal), "fm-dscr-existing"],
            ["Headroom", fmt(cap.headroom), "fm-dscr-headroom"],
            ["Based on", cap.base_year ? `${yl[YEARS.indexOf(cap.base_year)] || cap.base_year.toUpperCase()} CFADS ${fmt(cap.base_cfads)}` : "No positive CFADS yet", "fm-dscr-base"],
          ].map(([l, v, tid]) => (
            <div key={l} className="rounded-lg px-3 py-2.5" data-testid={tid} style={{ backgroundColor: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}>
              <div className="text-[9px] uppercase tracking-widest text-white/40 font-bold">{l}</div>
              <div className="text-sm font-extrabold text-white mt-0.5">{v}</div>
            </div>
          ))}
        </div>
        <div className="text-[10px] text-white/35 mt-2">Capacity assumes {(cap.rate * 100).toFixed(0)}% interest over {cap.term_months} months at a {d.target_dscr}× DSCR floor.</div>
      </div>
      <div className="rounded-lg overflow-x-auto" style={{ border: "1px solid rgba(123,211,206,0.12)" }}>
        <table className="text-xs w-full">
          <thead><tr style={{ backgroundColor: C.panel }}>
            <th className="px-3 py-2 text-left text-white/50 font-bold">Year</th>
            {YEARS.map((y, i) => <th key={y} className="px-3 py-2 text-right font-bold" style={{ color: C.orange }}>{yl[i]}</th>)}
          </tr></thead>
          <tbody>
            {rows.map(([k, label]) => (
              <tr key={k} className="border-t border-white/5">
                <td className={`px-3 py-1.5 whitespace-nowrap ${k === "cfads" || k === "debt_service" ? "font-bold text-white" : "text-white/60"}`}>{label}</td>
                {YEARS.map((y) => <td key={y} className="px-3 py-1.5 text-right text-white/80 whitespace-nowrap">{fmt(d.years[y]?.[k])}</td>)}
              </tr>
            ))}
            <tr className="border-t border-white/10">
              <td className="px-3 py-2 font-bold text-white">DSCR</td>
              {YEARS.map((y) => {
                const yr = d.years[y];
                const s = yr?.status ? STATUS[yr.status] : null;
                return (
                  <td key={y} className="px-3 py-2 text-right" data-testid={`fm-dscr-${y}`}>
                    {yr?.dscr == null ? <span className="text-white/30 text-[10px]">NO DEBT</span> : (
                      <span className="text-[10px] font-bold px-2 py-1 rounded-full" style={{ backgroundColor: s.bg, color: s.color }}>
                        {yr.dscr}× {s.label}
                      </span>
                    )}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
